// extracted by mini-css-extract-plugin
export var chevron = "_j8-3";
export var chevronRotated = "_j8-4";
export var image = "_j8-1";
export var imageContainer = "_j8-0";
export var shippingAddress = "_j8-2";